import { createContext } from 'react';
import type { ValidationContextValue } from './types';

export const ValidationContext = createContext<ValidationContextValue | null>(null);
